import { render, staticRenderFns } from "./FormBoxInput.vue?vue&type=template&id=cad00cbc&scoped=true"
import script from "./FormBoxInput.vue?vue&type=script&lang=js"
export * from "./FormBoxInput.vue?vue&type=script&lang=js"
import style0 from "./FormBoxInput.vue?vue&type=style&index=0&id=cad00cbc&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cad00cbc",
  null
  
)

export default component.exports